import React from 'react';
import Logo from './Logo';
import { COMPANY } from '../config/company';

const LINKS = [
  ['/#products', 'Products'],
  ['/#services', 'Services'],
  ['/website-health-check', 'Website Health Check'],
  ['/#company', 'Company'],
  ['/contact', 'Contact'],
  ['/privacy', 'Privacy'],
  ['/terms', 'Terms'],
];

const Footer = ({ surface = 'warm' }) => (
  <footer className={`${surface === 'white' ? 'bg-white' : 'bg-[#fffaf2]'} px-6 py-10 text-ink md:px-12 lg:px-16`}>
    <div className="mx-auto flex max-w-[90rem] flex-col items-start gap-8 md:flex-row md:items-center">
      <a href="/" className="mr-auto inline-flex items-center" aria-label="Lokyis Ltd home">
        <Logo heightClass="h-8" />
      </a>
      <nav aria-label="Footer navigation">
        <ul className="flex flex-wrap gap-x-7 gap-y-3">
          {LINKS.map(([href, label]) => <li key={href}><a href={href} className="footer-link">{label}</a></li>)}
        </ul>
      </nav>
      <p className="font-hand text-xl text-ink/70 md:ml-6">Useful technology<br />for a kinder tomorrow.</p>
    </div>
    <div className="mx-auto mt-8 flex max-w-[90rem] flex-wrap justify-between gap-3 border-t border-ink/10 pt-5 text-xs text-ink/50">
      <p>© {new Date().getFullYear()} {COMPANY.legalName}. All rights reserved.</p>
      <a href={`mailto:${COMPANY.supportEmail}`} className="hover:text-ink">{COMPANY.supportEmail}</a>
    </div>
  </footer>
);

export default Footer;
